<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Total Anual Previsto</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item">Total Anual Previsto</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                        <v-form>
                                            <v-container>
                                                <div class="row gp-query-filters gp-query-filters--two">
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <v-autocomplete v-model="GarantidoraSelected" :items="ListGarantidorasGeral"
                                                                item-title="garNomeEmpresa" item-value="garId" density="compact" variant="outlined"
                                                                placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhuma garantidora encontrada" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Ano Referência</label>
                                                            <select v-model="AnoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListAnoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12 gp-query-actions">
                                                        <div class="form-group">
                                                            <button type="button" class="btn btn-info"
                                                                style="color:#ffffff;" @click="Filtar()">
                                                                <i class="fas fa-search"></i> Pesquisar
                                                            </button>
                                                            <a href="#" @click="Cancel()"
                                                                class="btn btn-outline-secondary"><i class="fas fa-eraser"></i> Limpar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Resultado</h4>
                                </div>
                                <div style="float: right;" v-if="TotalGrid != 0">
                                    <strong>Valor Total Filtrado: R$ {{ TotalGrid }}</strong>
                                </div>
                            </div>
                            <div class="card-body"
                                v-if="ListCobrancas != '' && ListGarantidorasGeral != null">
                                <adm-data-table :headers="headers" :items="ListCobrancas" v-model="itemsSelected"
                                    :show-filters="false"
                                    :show-export="false"
                                    :export-formatters="formatadoresExportacao"
                                    :export-number-formats="formatosNumericosExportacao"
                                    :filter-options="{ garId: ListGarantidorasGeral.map(item => ({ title: item.garNomeEmpresa, value: item.garId })) }"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina" file-name="total-anual-previsto">
                                    <template #item-garId="item">
                                        <span>{{ListGarantidorasGeral.filter(x => x.garId ==
                                            item.garId)[0].garNomeEmpresa}}</span>
                                    </template>
                                    <template #item-janeiro="item">
                                        <span>{{ formatarValor(item.janeiro) }}</span>
                                    </template>
                                    <template #item-fevereiro="item">
                                        <span>{{ formatarValor(item.fevereiro) }}</span>
                                    </template>
                                    <template #item-marco="item">
                                        <span>{{ formatarValor(item.marco) }}</span>
                                    </template>
                                    <template #item-abril="item">
                                        <span>{{ formatarValor(item.abril) }}</span>
                                    </template>
                                    <template #item-maio="item">
                                        <span>{{ formatarValor(item.maio) }}</span>
                                    </template>
                                    <template #item-junho="item">
                                        <span>{{ formatarValor(item.junho) }}</span>
                                    </template>
                                    <template #item-julho="item">
                                        <span>{{ formatarValor(item.julho) }}</span>
                                    </template>
                                    <template #item-agosto="item">
                                        <span>{{ formatarValor(item.agosto) }}</span>
                                    </template>
                                    <template #item-setembro="item">
                                        <span>{{ formatarValor(item.setembro) }}</span>
                                    </template>
                                    <template #item-outubro="item">
                                        <span>{{ formatarValor(item.outubro) }}</span>
                                    </template>
                                    <template #item-novembro="item">
                                        <span>{{ formatarValor(item.novembro) }}</span>
                                    </template>
                                    <template #item-dezembro="item">
                                        <span>{{ formatarValor(item.dezembro) }}</span>
                                    </template>
                                    <template #item-totalAno="item">
                                        <span>{{ formatarValor(item.totalAno) }}</span>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'

export default {
    name: 'TotalAnualPrevistoGarantePayView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        User: [],
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        itemsSelected: [],
        ListCobrancasGeral: [],
        ListCobrancas: [],
        GarantidoraSelected: null,
        ListGarantidorasGeral: [],
        ImobiliariaSelected: null,
        ListImobiliariasGeral: [],
        ListImobiliarias: [],
        PagamentoSelected: null,
        ListPagamentosGeral: [],
        AnoSelected: null,
        ListAnoGeral: [],
        MesSelected: null,
        ListMesGeral: [
            { Id: 1, Nome: 'Janeiro' },
            { Id: 2, Nome: 'Fevereiro' },
            { Id: 3, Nome: 'Março' },
            { Id: 4, Nome: 'Abril' },
            { Id: 5, Nome: 'Maio' },
            { Id: 6, Nome: 'Junho' },
            { Id: 7, Nome: 'Julho' },
            { Id: 8, Nome: 'Agosto' },
            { Id: 9, Nome: 'Setembro' },
            { Id: 10, Nome: 'Outubro' },
            { Id: 11, Nome: 'Novembro' },
            { Id: 12, Nome: 'Dezembro' }
        ],
        TotalGrid: 0,
    }),
    computed: {
        formatadoresExportacao() {
            const campos = ['janeiro', 'fevereiro', 'marco', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro', 'totalAno'];
            return Object.fromEntries(campos.map(campo => [campo, value => Number(value || 0)]));
        },
        formatosNumericosExportacao() {
            const campos = ['janeiro', 'fevereiro', 'marco', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro', 'totalAno'];
            return Object.fromEntries(campos.map(campo => [campo, '#,##0.00']));
        }
    },
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            if (valor == null || valor === '') {
                return '';
            }

            // 2) Tenta converter pra número
            // Se vier como string “2580.08” ou já for number, isso resolve
            const num = Number(valor);

            // 3) Se não for um número válido, faz fallback
            if (isNaN(num)) {
                return '';
            }

            // 4) Agora que é número, aplica o toLocaleString com duas casas decimais
            return num.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        Cancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        Filtar() {
            if (this.AnoSelected === '' || this.AnoSelected === null) {
                this.$mensagemAviso("Selecione Ano Referência.")
            }
            else {
                let garant = 0;
                let ano = 0;
                if (this.GarantidoraSelected != null) {
                    garant = this.GarantidoraSelected;
                }
                if (this.AnoSelected != null) {
                    ano = this.AnoSelected;
                }
             axios.get(`/Telas/TotalAnualPrevistoGarantePay/GetGarIdAnual/` + garant + '/' + ano)
                    .then(response => {
                        this.ListCobrancasGeral = response.data;
                        this.ListCobrancas = this.ListCobrancasGeral;
                        this.TotalGrid = this.formatarValor(this.ListCobrancasGeral.reduce(
                            (soma, item) => soma + Number(item.totalAno || 0),
                            0
                        ));
                    });
            }
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "Garantidora", value: "garId", sortable: true, });
            this.headers.push({ text: "Pagamento", value: "pmbFormaPgto", sortable: true, });
            this.headers.push({ text: "Janeiro", value: "janeiro", sortable: true, });
            this.headers.push({ text: "Fevereiro", value: "fevereiro", sortable: true, });
            this.headers.push({ text: "Março", value: "marco", sortable: true, });
            this.headers.push({ text: "Abril", value: "abril", sortable: true, });
            this.headers.push({ text: "Maio", value: "maio", sortable: true, });
            this.headers.push({ text: "Junho", value: "junho", sortable: true, });
            this.headers.push({ text: "Julho", value: "julho", sortable: true, });
            this.headers.push({ text: "Agosto", value: "agosto", sortable: true, });
            this.headers.push({ text: "Setembro", value: "setembro", sortable: true, });
            this.headers.push({ text: "Outubro", value: "outubro", sortable: true, });
            this.headers.push({ text: "Novembro", value: "novembro", sortable: true, });
            this.headers.push({ text: "Dezembro", value: "dezembro", sortable: true, });

            this.headers.push({ text: "Total", value: "totalAno", sortable: true, });
        },
        exportCSV() {
            if (this.ListCobrancas.length === 0) {
                alert("Não há dados para exportar.");
                return;
            }

            let _Garantidora = "Todas";
            let _Ano = "Todos";

            if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
                _Garantidora = this.ListGarantidorasGeral.filter(x => x.garId == this.GarantidoraSelected)[0].garNomeEmpresa;
            }

            if (this.AnoSelected != '' && this.AnoSelected != null) {
                _Ano = this.ListAnoGeral.filter(x => x.Id == this.AnoSelected)[0].Nome;
            }
            // Cria as linhas de filtros (ajuste os nomes dos filtros conforme necessário)
            const filtroCSV =
                `Garantidora: ${_Garantidora}\n` +
                `Ano: ${_Ano}\n\n`;

            const csvHeader = this.headers
                .map(h => h.text)
                .join(";") + "\n";

            // 2) Liste as chaves dinamicamente (aqui já só as que sobraram após slice)
            const keys = this.headers
                .map(h => h.value);


            const csvRows = this.ListCobrancas
                .map(item => {
                    return keys
                        .map(key => {
                            const val = item[key];
                           if (key === "garId") {
                                
                                // encontra o cliente correspondente
                                const cli = this.ListGarantidorasGeral.find(c => c.garId === item.garId) || {};
                                return cli["garNomeEmpresa"] || "";
                            }
                            // 1) Se for campo de forma de pagamento, devolve “cru”
                            if (key === 'pmbFormaPgto') {
                            return val || '';
                            }

                            // 2) Para qualquer outro campo não-nulo, formata o valor
                            if (val != null) {
                            return this.formatarValor(val);
                            }

                            // 3) Fallback para string vazia
                            return '';
                        })
                        .join(";");
                })
                .join("\n");

            // Concatena os filtros, o cabeçalho e as linhas de dados
            const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + filtroCSV + csvHeader + csvRows;

            // Cria o link de download
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "RelatorioTotalAnualPrevistoGarantePay.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async Get() {
          
         await axios.get(`/Telas/TotalAnualPrevistoGarantePay/GetDados`)
               .then(response => {
                 this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                        b.garNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );

                    this.ListAnoGeral = [];
                    const anoAtual = new Date().getFullYear();
                    this.ListAnoGeral = Array.from({ length: 7 }, (_, i) => {
                        const ano = anoAtual - 1 + i;
                        return { Id: ano, Nome: String(ano) };
                    });

                  this.ListPagamentosGeral = response.data.cadFormasPagamentos;
                  this.montaGrid();
         });

        }
    },
    created() {
        this.Get();

    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
